<template>
  <div class="wrapper">
    <div class="apply-container">
      <div class="pub-title title1" id="q0">
        <span>{{ $t('applyTit') }}</span>
      </div>
      <div class="form-apply">
        <el-form ref="form" :model="form" :rules="rules" label-width="0">
          <h4>
            <i18n path="companyInfo" tag="div">
              {{ companyInfo }}
            </i18n>
          </h4>

          <div class="form">
            <el-form-item
              :label="
                i18n.locale == 'ch' ? '公司名称（中文）' : 'Company name（CN）'
              "
              prop="company"
            >
              <el-input
                v-model="form.company"
                :hide-required-asterisk="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="
                i18n.locale == 'ch' ? '公司名称（英文）' : 'Company name（EN）'
              "
            >
              <el-input v-model="form.waicCompanyNameEN"></el-input>
            </el-form-item>
            <el-form-item
              :label="
                i18n.locale == 'ch'
                  ? '公司组织性质'
                  : 'Nature of company organization'
              "
              prop="waicEnterpriseType"
            >
              <el-select v-model="form.waicEnterpriseType" placeholder="">
                <el-option
                  v-for="item in natureList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="
                i18n.locale == 'ch'
                  ? '公司主营AI相关（多选）'
                  : 'Company' +
                    '’' +
                    's main business is related to AI(Multiple choice'
              "
              prop="waicMainBusiness"
            >
              <el-select
                v-model="form.waicMainBusiness"
                placeholder=""
                multiple
              >
                <el-option
                  v-for="item in businessList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="i18n.locale == 'ch' ? '公司地址' : 'Company address'"
            >
              <el-input v-model="form.street"></el-input>
            </el-form-item>
            <el-form-item
              :label="i18n.locale == 'ch' ? '公司网站' : 'Company website'"
            >
              <el-input v-model="form.website"></el-input>
            </el-form-item>
            <el-form-item
              :label="
                i18n.locale == 'ch'
                  ? '意向展区'
                  : 'Intention exhibition area'
              "
              prop="waicIndustry"
            >
              <el-select v-model="form.waicIndustry" placeholder="">
                <el-option
                  v-for="item in showareaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="form.showarea"></el-input> -->
            </el-form-item>
            <el-form-item
              :label="i18n.locale == 'ch' ? '意向面积' : 'Intended area'"
              prop="acreage "
            >
              <el-input v-model="form.acreage"></el-input>
            </el-form-item>
            <el-form-item
              :label="
                i18n.locale == 'ch'
                  ? '是否举办论坛'
                  : 'Hold forum or not'
              "
              prop="waicHaveForum"
            >
              <el-select v-model="form.waicHaveForum" placeholder="">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="contacts">
            <h4>
              <i18n path="contactInfo" tag="div">
                {{ contactInfo }}
              </i18n>
            </h4>
            <div class="form">
              <el-form-item
                :label="i18n.locale == 'ch' ? '姓名' : 'Name'"
                prop="lastName"
              >
                <el-input v-model="form.lastName"></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.locale == 'ch' ? '部门' : 'Department'"
                prop="waicDepartment"
              >
                <el-input v-model="form.waicDepartment"></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.locale == 'ch' ? '职务' : 'Post'"
                prop="title"
              >
                <el-input v-model="form.title"></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.locale == 'ch' ? '手机' : 'Cell-phone number'"
                prop="mobilePhone"
              >
                <el-input v-model="form.mobilePhone" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.locale == 'ch' ? '邮箱' : 'E-mail'"
                prop="email"
              >
                <el-input v-model="form.email"></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.locale == 'ch' ? '传真' : 'Fax'"
                prop="fax"
              >
                <el-input v-model="form.fax"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="tips">
            <i18n path="required" tag="div">
              {{ required }}
            </i18n>
          </div>
          <!-- <div class="note">
            <p>注意事项</p>
            <p>（1）签名和日期请手写；</p>
            <p>（2）请随表提交营业执照复印件；</p>
            <p>（3）参会申请表截止日期为2021 年4月30日（含当日）。提交方式：扫描件（pdf格式）发至联系人邮箱。</p>
          </div> -->
          <div class="submit-btn">
            <el-button @click="onSubmit('form')" :loading="loading">
              <i18n path="submit" tag="div">
                {{ submit }}
              </i18n>
            </el-button>
          </div>
        </el-form>
      </div>
      <div class="pub-title title1" id="q0">
        <span>{{ $t('committee') }}</span>
      </div>
      
      <!-- 联系我们 -->
      <div class="inner inner2" id="q4">
        <div class="contact title-line">
          <ul>
            <li v-for="(item, index) in contactUs" :key="index">
              <div class="contact-title">{{ item['name' + En] }}</div>
              <div class="contact-content">
                <span v-for="(ite, ind) in item.values" :key="ind" v-html="ite['name' + En]"></span>
              </div>
              <ul v-if="item.children">
                <li v-for="(ite, ind) in item.children" :key="ind">
                  <div class="contact-title">{{ ite['name' + En] }}</div>
                  <div class="contact-content">
                    <span v-for="(ite, ind) in ite.values" :key="ind" v-html="ite['name' + En]"></span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tk" v-if="show" :style="{ top: scrollTop + clientHeight/2 + 'px' }">
      <span>{{ $t('zltj') }}</span>
      <div class="btn" @click="show = false">{{ $t('confirm') }}</div>
    </div>
  </div>
</template>
<script>
import protal from "@/api/protal";
const initForm = {
    acreage: "",
    company: "",
    leadSource: "官网报名",
    status: "New",
    email: "",
    fax: "",
    lastName: "",
    mobilePhone: "",
    street: "",
    title: "",
    waicCompanyNameEN: "",
    waicDepartment: "",
    waicEnterpriseType: "",
    waicHaveForum: "",
    waicIndustry: "",
    waicMainBusiness: "",
    website: "",
  }
export default {
  data() {
    // 自定义验证邮箱
    var checkEmail = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        console.log(regEmail.test(value));
        return callback();
      } else {
        callback(new Error("请输入合法邮箱"));
      }
    };
    // 自定义验证手机号
    var checkPhone = (rule, value, callback) => {
      console.log(typeof value, "\\\\/");
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    };
    return {
      contactUs: [],
      show: false,
      form: JSON.parse(JSON.stringify(initForm)),
      waicHaveForum: "",
      rules: {
        company: [
          {
            required: true,
            message: "请填写公司/组织（中文）",
            trigger: "blur",
          },
        ],
        waicEnterpriseType: [
          { required: true, message: "请选择公司组织性质", trigger: "blur" },
        ],
        waicMainBusiness: [
          { required: true, message: "请选择公司主营AI相关", trigger: "blur" },
        ],
        waicIndustry: [
          { required: true, message: "请填写意向展区", trigger: "blur" },
        ],
        acreage: [
          { required: true, message: "请填写意向面积", trigger: "blur" },
        ],
        waicHaveForum: [
          { required: true, message: "请选择是否举办论坛", trigger: "blur" },
        ],
        lastName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        waicDepartment: [
          { required: true, message: "请填写部门", trigger: "blur" },
        ],
        title: [{ required: true, message: "请填写职务", trigger: "blur" }],
        mobilePhone: [
          { required: true, message: "请填写手机", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请填写邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
      },
      natureList: [
        { id: 0, name: "国有" },
        { id: 1, name: "私营" },
        { id: 2, name: "外商独资" },
        { id: 3, name: "中外合资" },
        { id: 4, name: "协会" },
        { id: 5, name: "商学院高校研究所" },
      ],
      businessList: [
        { id: 0, name: "智能芯片" },
        { id: 1, name: "计算机视觉" },
        { id: 2, name: "语音识别&NLP" },
        { id: 3, name: "大数据" },
        { id: 4, name: "云计算" },
        { id: 5, name: "智能制造" },
        { id: 6, name: "智慧教育" },
        { id: 7, name: "智慧金融" },
        { id: 8, name: "智能商业" },
        { id: 9, name: "智慧医疗" },
        { id: 10, name: "智慧城市大数据" },
        { id: 11, name: "智能驾驶" },
        { id: 12, name: "智能物流" },
      ],
      showareaList: [
        { id: 0, name: "AI先导" },
        { id: 1, name: "基础技术" },
        { id: 2, name: "智能驾驶" },
        { id: 3, name: "工业互联" },
        { id: 4, name: "城市管理与商业" },
        { id: 5, name: "智慧医疗" },
        { id: 6, name: "金融科技" },
        { id: 7, name: "智慧教育" },
        { id: 8, name: "智能机器人" },
        { id: 9, name: "AI生态圈（前沿项目、投资机构）" },
      ],
      gradeList: [
        { id: 0, name: "战略合作伙伴" },
        { id: 1, name: "卓越合作伙伴" },
        { id: 2, name: "精英合作伙伴" },
        { id: 3, name: "制定合作伙伴" },
      ],
      fieldList: [
        { id: 0, name: "翻译" },
        { id: 1, name: "出行" },
        { id: 2, name: "金融服务" },
        { id: 3, name: "人力资源服务" },
        { id: 4, name: "技术支持" },
      ],
      statusList: [
        { id: 1, name: "是" },
        { id: 0, name: "否" },
      ],
      applyTit: "",
      apply: "",
      companyInfo: "",
      required: "",
      submit: "",
      contactInfo: "",
      committee: "",
      contactWay: "",
      waicMainBusiness: "",
      loading: false,
    };
  },
  created() {
    this.pageView('gw_chapplypage')
  },
  mounted() {
    protal.getJson('organizing_committee', data => {
        this.contactUs = data || {}
      })
  },
  methods: {
    onSubmit(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const form = JSON.parse(JSON.stringify(this.form))
          // alert("submit!");
          if (Array.isArray(form.waicMainBusiness)) {
            form.waicMainBusiness = form.waicMainBusiness.join(";");
          }
          form.waicHaveForum = form.waicHaveForum == 1 ? true : false;
          protal
            .apply(form)
            .then((res) => {
              this.loading = false;
              if (res.code == "0000") {
                this.$message.success("提交成功");
                this.show = true
                this.initForm = JSON.parse(JSON.stringify(initForm))

                this.$jsAPI('track','joinSubmit',
                    {
                      'companyName_var': this.form.company,
                      'companyOrganization_var': this.form.waicEnterpriseType,
                      'companyExecutive_var': this.form.waicMainBusiness.join('|') ? '|' + this.form.waicMainBusiness.join('|') + '|' : '无',
                      'intentionalArea_var': this.form.waicIndustry,
                      'whetherHold_var': this.form.waicHaveForum ? '是' : '否',
                    }
                );
                gio('track','joinSubmit',
                    {
                      'companyName_var': this.form.company,
                      'companyOrganization_var': this.form.waicEnterpriseType,
                      'companyExecutive_var': this.form.waicMainBusiness.join('|') ? '|' + this.form.waicMainBusiness.join('|') + '|' : '无',
                      'intentionalArea_var': this.form.waicIndustry,
                      'whetherHold_var': this.form.waicHaveForum ? '是' : '否',
                    }
                );
                console.log('joinSubmit', {
                      'companyName_var': this.form.company,
                      'companyOrganization_var': this.form.waicEnterpriseType,
                      'companyExecutive_var': this.form.waicMainBusiness.join('|') ? '|' + this.form.waicMainBusiness.join('|') + '|' : '无',
                      'intentionalArea_var': this.form.waicIndustry,
                      'whetherHold_var': this.form.waicHaveForum ? '是' : '否',
                    })
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          this.loading = false
          this.$message.error("请填写信息！");
          // this.$message({
          //   duration: 100000,
          //   content: "error submit!!",
          // });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 1.65rem 0 1.5rem;
  background: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
  background-size: 100% auto;
}

/deep/ .el-message {
  font-size: .20rem !important;
  i {
  }
  .el-message__icon.el-icon-info {
    font-size: .20rem !important;
  }
}

.tk {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 4.55rem;
  height: 2.50rem;
  transform: translate(-50%, -50%);
  background: #E8E8E8;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    padding-top: .57rem;
    font-size: .22rem;
    font-weight: 500;
    color: #494949;
    line-height: 1.5;
  }

  .btn {
    width: 2rem;
    height: .64rem;
    background: #2F9FFA;
    border-radius: .32rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .26rem;
    line-height: 1;
    color: #fff;
    cursor: pointer;
  }
}
@media screen and (min-width: 769px) {

  .inner {
    width: 100%;
    margin: 0 auto;
  }
  .inner2 {
    margin-top: 1.45rem;
  }
  .wrapper {
    padding-top: 1.80rem;
    padding-bottom: .97rem;
    .apply-container {
      margin: 0 auto;
      width: 12.74rem;
    }
    .form-apply {
      background: #fff;
      padding: .55rem 1.32rem .51rem 1.32rem;
      padding-left: 1.32rem;
      padding-right: 1.32rem;
      margin-top: .52rem;
      margin-bottom: .97rem;
      border-radius: .08rem;
      h4 {
        padding-bottom: .13rem;
        border-bottom: 1px solid #979797;
        font-size: .25rem;
        color: #494949;
        line-height: .30rem;
        font-weight: normal;
        margin-bottom: .42rem;
      }
      .form {
        display: flex;
        flex-wrap: wrap;
      }
      /deep/ .el-form {
        .el-form-item {
          width: 50%;
          box-sizing: border-box;
          padding-right: .59rem;
          text-align: left;
          margin-bottom: .31rem;
          font-size: 0;
          &:nth-child(2n) {
            padding-right: 0;
          }
        }
        .el-form-item__label {
          line-height: .24rem;
          font-size: .20rem;
          color: #494949;
          margin-bottom: .08rem;
          float: none;
          white-space: nowrap;
        }
        .el-form-item__content {
          margin-top: .08rem;
        }
        .el-select {
          width: 100%;
        }
        .submit-btn {
          text-align: center;
          margin-top: .66rem;
          .el-button {
            width: 2rem;
            height: .64rem;
            background: #2F9FFA;
            border-radius: .32rem;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .26rem;
            line-height: 1;
            color: #fff;
            cursor: pointer;
          }
        }
      }
      .contacts {
        margin-top: .30rem;
        h4 {
          margin-bottom: .51rem;
        }
      }
      .note {
        text-align: left;
        font-size: .18rem;
        line-height: .30rem;
        color: #525252;
        margin-top: .25rem;
      }
      .tips {
        text-align: left;
        color: #ff0000;
        font-size: .21rem;
        line-height: .24rem;
      }
    }
    .form-box {
      display: flex;
      flex-wrap: wrap;
      padding-left: 1.32rem;
      padding-right: 1.32rem;
      .form-group {
        width: 50%;
        padding-left: .30rem;
        padding-right: .30rem;
        margin-bottom: .30rem;
        &:nth-child(even) {
          padding-right: 0;
        }
        &:nth-child(odd) {
          padding-left: 0;
        }
        label {
          display: block;
          text-align: left;
          line-height: .24rem;
          font-size: .20rem;
          color: #494949;
          margin-bottom: .08rem;
        }
        input {
          width: 100%;
          height: .39rem;
          border: 1px solid #d9d9d9;
          border-radius: .06rem;
        }
        select {
          width: 100%;
          height: .39rem;
          border: 1px solid #d9d9d9;
          border-radius: .06rem;
        }
      }
    }
    .apply-contact {
      background: #fff;
      text-align: left;
      margin-top: .67rem;
      padding: .37rem 0 .45rem 1.31rem;
      border-radius: .08rem;
      div {
        overflow: hidden;
        font-size: .22rem;
        color: #000;
        line-height: .30rem;
        &.contact-tit {
          letter-spacing: 2px;
        }
        b {
          float: left;
          font-weight: normal;
          letter-spacing: 2px;
        }
        p {
          float: left;
          span {
            display: block;
          }
        }
      }
    }
  }

.contact {
  width: 100%;
  background: #F6F7F7;
  border-radius: .16rem;
  padding: .47rem .4rem .07rem;
  margin-top: .55rem;

  ul {
    display: flex;
    justify-content: space-between;

    li {
      flex: 1;
      margin-right: .6rem;

      &:last-child {
        margin-right: .2rem;
      }

      &:first-child {
        flex: 2;
      }

      .contact-title {
        font-size: .26rem;
        font-weight: bold;
        color: #343434;
        line-height: 1;
        padding-bottom: .16rem;
        border-bottom: 1px solid #ccc;
      }

      .contact-content {
        margin-top: .17rem;

        span {
          display: block;
          margin-bottom: .32rem;

          /deep/ strong {
            display: block;
            font-size: .22rem;
            line-height: .3rem;
            font-weight: bold;
            margin-bottom: .12rem;
          }

          /deep/ p {
            font-size: .18rem;
            line-height: .2rem;
            margin: 0;
          }
        }
      }

      &:first-child {
        .contact-content {
          display: flex;
          flex-wrap: wrap;

          /deep/ span {
            flex: 3.2rem;
          }
        }
      }
    }
  }
}
}

// @media screen and (min-width: 1320px) {
//   .tk {
//     top: 50% !important;
//   }
// }

@media screen and (max-width: 768px) {

  .inner {
    width: 5.3rem;
    margin: 0 auto;
  }

  .inner2 {
    margin-top: 1.25rem;
  }

  .tk {
    background: #fff;
    width: 5rem;
    height: 2.8rem;
    top: 50% !important;

    span {
      padding-top: .6rem;
      font-size: .28rem;
    }

    .btn {
      width: 2rem;
      height: .7rem;
      font-size: .28rem;
      margin-top: .5rem;
    }
  }
  .wrapper {
    .apply-title {
      height: 1.76rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
    }
    .apply-container {
      margin: 0 auto;
    }
    .form-apply {
      padding: 0.22rem 1.1rem 0.57rem 1.1rem;
      margin-top: 0.3rem;
      margin-bottom: 0.43rem;
      h4 {
        padding-bottom: 0.12rem;
        font-size: 0.3rem;
        color: #494949;
        line-height: 0.36rem;
        font-weight: normal;
        margin-bottom: 0.44rem;
      }
      .form {
        display: flex;
        flex-wrap: wrap;
      }
      /deep/ .el-form {
        .el-form-item {
          width: 100%;
          padding-right: 0;
          text-align: left;
          margin-bottom: 0.44rem;
          font-size: 0;
        }
        .el-form-item__label {
          line-height: 0.34rem;
          font-size: 0.28rem;
          color: #494949;
          margin-bottom: 8px;
          float: none;
        }
        .el-form-item__content {
          margin-top: 0.11rem;
          line-height: 0.56rem;
          .el-input {
            input {
              line-height: 0.56rem;
              background: none;
              border: 1px solid #979797;
              border-radius: 0.08rem;
              outline: none;
              font-size: .24rem;
            }
          }
        }
        .el-input__inner {
          height: 0.56rem;
        }
        .el-select {
          width: 100%;
        }
        .submit-btn {
          text-align: center;
          margin-top: 0.46rem;
          font-size: 0;
          .el-button {
            width: 2.1rem;
            height: .56rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #D8D8D8;
            border-radius: 0;
            font-size: .24rem;
            box-sizing: border-box;
            letter-spacing: .12rem;
            color: #525252;
            padding: 0;
            padding-left: .12rem;
            margin: 0 auto;
            outline: none;
          }
        }
      }
      .contacts {
        margin-top: 0.34rem;
        h4 {
          margin-bottom: 0.56rem;
        }
      }
      .note {
        text-align: left;
        font-size: 0.22rem;
        line-height: 0.36rem;
        color: #525252;
        margin-top: 0.13rem;
      }
      .tips {
        text-align: left;
        color: #ff0000;
        font-size: 0.28rem;
        line-height: 0.34rem;
      }
    }
    .apply-contact {
      text-align: left;
      margin-top: 0.43rem;
      padding: 0.37rem 0.43rem 0.5rem 0.43rem;
      div {
        display: flex;
        overflow: hidden;
        font-size: 0.18rem;
        color: #757575;
        line-height: 0.36rem;
        &.contact-tit {
          letter-spacing: 0.02rem;
        }
        b {
          font-weight: normal;
          letter-spacing: .04rem;
        }
        p {
          flex: 1;
          overflow: hidden;
          span {
            display: block;
            white-space: nowrap;
          }
        }
        &:first-child {
          font-weight: bold;
        }
      }
    }
  }

  /deep/ .el-input__icon {
    display: none;
  }

.contact {
  width: 100%;
  background: #F6F7F7;
  border-radius: .16rem;
  padding: .36rem .36rem .41rem;
  margin-top: .6rem;

  ul {

    li {
      margin-bottom: .48rem;

      &:last-of-type {
        margin-bottom: 0;
      }

      .contact-title {
        font-size: .3rem;
        font-weight: bold;
        color: #343434;
        line-height: 1;
        padding-bottom: .2rem;
        border-bottom: 1px solid #ccc;
      }

      .contact-content {
        margin-top: .16rem;

        span {
          display: block;
          margin-bottom: .2rem;

          /deep/ strong {
            font-size: .28rem;
            font-weight: bold;
            display: block;
            margin-bottom: .1rem;
          }

          /deep/ p {
            font-size: .28rem;
            height: .32rem;
            display: block;
          }
        }
      }
    }
  }
}
}
</style>


// WEBPACK FOOTER //
// src/pages/apply/index.vue